var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4021 5.07146L9.26859 0.937964C8.01475 -0.312655 5.98527 -0.312655 4.73142 0.937964L0.597932 5.07146C0.213808 5.45353 -0.00149608 5.97339 7.82594e-06 6.5152V12.569C0.00129298 13.3592 0.641901 13.9993 1.43211 13.9999H12.5679C13.3581 13.9993 13.9987 13.3592 14 12.569V6.5152C14.0015 5.97339 13.7862 5.45353 13.4021 5.07146ZM12.25 12.2499H9.33334V10.3938C9.33334 9.16374 8.3362 8.1666 7.10617 8.1666H6.89385C5.66382 8.1666 4.66668 9.16374 4.66668 10.3938V12.2499H1.75V6.5152C1.7502 6.43785 1.78077 6.36369 1.83518 6.3087L5.96867 2.17521C6.53811 1.60562 7.46147 1.60551 8.03107 2.17494C8.03115 2.17502 8.03126 2.17513 8.03134 2.17521L12.1648 6.3087C12.2192 6.36369 12.2498 6.43785 12.25 6.5152V12.2499H12.25Z",
    fill: "#67686D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInduction);
export default __webpack_public_path__ + "static/media/induction.f7ea959dd1ac12c462f279979e218ca1.svg";
export { ForwardRef as ReactComponent };